import { render, staticRenderFns } from "./SupplyTgLeftDetail.vue?vue&type=template&id=0c42b96c&scoped=true"
import script from "./SupplyTgLeftDetail.vue?vue&type=script&lang=js"
export * from "./SupplyTgLeftDetail.vue?vue&type=script&lang=js"
import style0 from "./SupplyTgLeftDetail.vue?vue&type=style&index=0&id=0c42b96c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42b96c",
  null
  
)

export default component.exports